const FormField = ({ field, value, onChange }) => {
  if (!field) return null;

  const commonProps = {
    name: field.name,
    onChange,
    required: field.required,
    value: value || "",
  };

  return (
    <div className="gmpqcw-form-group">
      <label className="gmpqcw-label">{field.label}</label>

      {["text", "email"].includes(field.type) && (
        <input className="gmpqcw-input" type={field.type} {...commonProps} />
      )}

      {field.type === "textarea" && (
        <textarea className="gmpqcw-textarea" {...commonProps}></textarea>
      )}

      {field.type === "select" && field.options && (
        <select className="gmpqcw-select" {...commonProps}>
          {field.options.map((option, idx) => (
            <option key={idx} value={option}>
              {option}
            </option>
          ))}
        </select>
      )}

      {["radio", "checkbox"].includes(field.type) && field.options && (
        field.options.map((option, idx) => (
          <label
            key={idx}
            className={field.type === "radio"
              ? "gmpqcw-radio-container"
              : "gmpqcw-checkbox-container"}
          >
            <input
              type={field.type}
              name={field.name}
              value={option}
              onChange={onChange}
            />
            <span></span> {option}
          </label>
        ))
      )}
    </div>
  );
};

export default FormField;
